import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CoinsService_GetMissionsHistoryLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.grpc.lazy';
import {useCustomerSession} from '@aboutyou/user';
import {useCoinsLatestAchievementsOpenedState} from '../../../../features/Coins/CoinsWallet/CoinsWalletContent/CoinsLatestAchievements/utils/useCoinsLatestAchievementsOpenedState';
import {useIsMissionsActive} from '../../../../features/Coins/utils/useIsMissionsActive';

export const useGetMissionsHistory = () => {
  const isMissionsActive = useIsMissionsActive();
  const session = useCustomerSession();
  const {isOpen} = useCoinsLatestAchievementsOpenedState();

  return useGrpcRequest(
    CoinsService_GetMissionsHistoryLazy,
    {
      session: session!,
    },
    {
      disabled: !isOpen || !isMissionsActive || !session,
      mockData: async () => {
        return (
          await import('../__mocks__/getMissionsHistory.mock')
        ).getMissionsHistory();
      },
    },
  );
};
